import {Box, Button, Typography} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetSupplierBalances } from "api/hooks/accounting";
import { useGetPaymentTypesList } from "api/hooks/billing";
import { useSelector } from "react-redux";
import { useState } from "react";
import FormDialog from "components/modal";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import ReconciliationTransactionsForm from "../forms/reconcilliationForm";
import moment from "moment";
import {requester} from "api/pesabackend";

export default function SupplierPayablesList({ setIsSuccess }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { paymentTypesList } = useGetPaymentTypesList(1, business_branch_id);
  const {supplierBalances, isLoadingSupplierBalances, setNewBalanceData} = useGetSupplierBalances(1, business_branch_id);
  const [amount, setAmount] = useState("");
  const [reconcilliationId, setReconcilliationId] = useState("");
  const [paymentTypes, setPaymentTypes] = useState([] );
  const [paymentId, setPaymentId] = useState("");
  const [memo, setMemo] = useState("");
  const [transactionDate, setTransactionDate] = useState(moment().format('YYYY-MM-DD'));
  const [isSubmittingReconcilliationTransaction, setIsSubmittingReconcilliationTransaction] = useState(false);
  const [openReconcilliationRecording, setOpenReconcilliationRecording] = useState(false);
  


  const handleChangePaymentId = (e) => {
    setPaymentId(e.target.value);
  };

  const handleChangeAmount = (e) => {
    setAmount(e.target.value);
  };

  const handleChangeTransactionDate = (e) => {
    setTransactionDate(e.target.value);
  };

  const handleChangeMemo = (e) => {
    setMemo(e.target.value);
  }

  const handleClickOpenReconcilliationRecording = (reconcilliationId) => {
    setReconcilliationId(reconcilliationId);
    setPaymentTypes(paymentTypesList);
    setOpenReconcilliationRecording(true);
  };

  const handleCloseReconcilliationRecording = () => {
    // setModal("");
    setOpenReconcilliationRecording(false);
  };

  const saveReconcilliationTransaction = async () => {
    setIsSubmittingReconcilliationTransaction(true)
    const submitData = {
      "supplier_id": reconcilliationId,
      "payment_type_id": paymentId,
      "amount": amount,
      "memo": memo,
      "date": transactionDate,
    }
    try {
      await requester.post("/accounting/supplier/reconciliation", submitData)
      setIsSubmittingReconcilliationTransaction(false);
      setOpenReconcilliationRecording(false);
      setNewBalanceData(true);
    }catch (err){
        setIsSubmittingReconcilliationTransaction(false)
    }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ marginBottom: "1rem" }}>Supplier Balances List</Typography>
      <Box>
        <ReportTable
          columns={[
            { label: "No.", width: 50 },
            { label: "Supplier Name" },
            { label: "Outstanding Balance" },
            { label: "Balance Parity" },
            { label: "Actions", align: "center" },
          ]}
          rows={supplierBalances}
          loading={isLoadingSupplierBalances}
          emptyMessage="No data found"
          renderRow={(row, index) => (
            <RRow key={row.id} index={index}>
              <RCell>{index + 1}</RCell>
              <RCell>{row.ledger_name}</RCell>
              <RCell>{row.balance.total}</RCell>
              <RCell>{row.balance.parity}</RCell>
              <RCell align="center">
                <Button
                  value={row.id}
                  size="small"
                  onClick={() => navigate("/ledgerTransactions", { state: { id: row.id, name: row.ledger_name,},})}
                >
                  View Ledger
                </Button>
                <Button
                  value={row.id}
                  size="small"
                  onClick={(e) =>handleClickOpenReconcilliationRecording(row.related_supplier)}
                >
                  Reconcile
                </Button>
              </RCell>
            </RRow>
          )}
        />
        <FormDialog
          open={openReconcilliationRecording}
          handleClose={handleCloseReconcilliationRecording}
          enableActions={true}
          title={"Record Reconcilliation"}
          buttonText="Save Reconcilliation"
          handleSubmit={saveReconcilliationTransaction}
          isSubmitting={isSubmittingReconcilliationTransaction}
          isSubmittingText={
            "Recording Reconcilliation, Please wait..."
          }
          textStatus={true}
          text={`Please note that this action is going to create a transaction record`}
          content={
            <ReconciliationTransactionsForm
              handleChangePaymentId={handleChangePaymentId}
              handleChangeAmount={handleChangeAmount}
              handleChangeTransactionDate={handleChangeTransactionDate}
              handleChangeMemo={handleChangeMemo}
              paymentTypes={paymentTypes}
            />
          }
        />
      </Box>
    </Box>
  );
}
